/**
 * Created by Mikhail Menshenin on 24.07.2024
 */

const TutorialScenario = function (name, options) {
    this.name = name;
    this.options = options;
    this.priority = options.priority || 0;
    this.manual = options.manual;

    this.steps = [];
    this.setStep(0);
};

TutorialScenario.prototype.isAvailable = function () {
    if (cleverapps.config.adminMode || cleverapps.environment.isAtlasAnalyzerScene()) {
        return false;
    }

    if (this.options.isAvailable) {
        return this.options.isAvailable();
    }
    return true;
};

TutorialScenario.prototype.start = function () {
    if (this.options.onStart) {
        this.options.onStart.call(this);
    }

    this.steps = this.options.listSteps();

    addCleaner(this.steps[this.steps.length - 1], () => {
        if (!cleverapps.focusManager.currentWindow()) {
            cleverapps.shadow.hide();
        }
    });

    this.startStep();
};

TutorialScenario.prototype.startNextStep = function () {
    this.logStepEvent(TutorialScenario.EVENTS.STEP_FINISH);

    this.stepNo++;
    this.startStep();
};

TutorialScenario.prototype.startStep = function () {
    this.logStepStart();
    const step = this.getCurrentStep();
    if (step) {
        step.start();
    }
};

TutorialScenario.prototype.getCurrentStep = function () {
    return this.steps[this.stepNo];
};

TutorialScenario.prototype.setStep = function (step) {
    this.stepNo = step;
};

TutorialScenario.prototype.onFinishScenario = function () {
    if (this.options.onFinish) {
        this.options.onFinish.call(this);
    }

    this.logScenarioFinish();
};

TutorialScenario.prototype.getLoggingName = function () {
    let name = this.name;
    if (this.options.prepareNameForLogging) {
        name = this.options.prepareNameForLogging(name);
    }
    return name;
};

TutorialScenario.prototype.logStepStart = function () {
    const name = this.getLoggingName();

    this.stepStartTime = Date.now();
    this.stepStats = {
        off: 0, target: 0, wrong: 0, lastTouchAt: this.stepStartTime
    };

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.STATS.TUTORIAL_STEP + name}_${this.stepNo}`);

    if (name === TutorialScenario.BASIC_TUTORIAL_NAME) {
        cleverapps.abExperiments.allLogEvent(`${cleverapps.EVENTS.STATS.TUTORIAL_STEP + name}_${this.stepNo}`);
    }
};

TutorialScenario.prototype.noteTouch = function (kind) {
    if (this.stepStats) {
        this.stepStats[kind] += 1;
        this.stepStats.lastTouchAt = Date.now();
    }
};

TutorialScenario.prototype.logStepEvent = function (event, extra) {
    if (!this.stepStats) {
        return;
    }

    const now = Date.now();
    const details = {
        ...extra,
        t: Math.round((now - this.stepStartTime) / 1000),
        idle: Math.round((now - this.stepStats.lastTouchAt) / 1000),
        off: this.stepStats.off,
        target: this.stepStats.target,
        wrong: this.stepStats.wrong
    };

    const params = {
        itemId: `${this.getLoggingName()}_${this.stepNo}`,
        value: details.hidden !== undefined ? details.hidden : details.t,
        details
    };

    cleverapps.metrics.logEvent(event, params);

    if (this.getLoggingName() === TutorialScenario.BASIC_TUTORIAL_NAME) {
        cleverapps.abExperiments.allLogEvent(event, params);
    }
};

TutorialScenario.prototype.logScenarioFinish = function () {
    if (this.name === TutorialScenario.BASIC_TUTORIAL_NAME) {
        if (cleverapps.rewardedPromoTracker) {
            cleverapps.rewardedPromoTracker.logTutorialFinish();
        }
    }
};

TutorialScenario.BASIC_TUTORIAL_NAME = "basic";

TutorialScenario.EVENTS = {
    STEP_FINISH: "tutorial_step_finish",
    STEP_QUIT: "tutorial_step_quit",
    STEP_HIDE: "tutorial_step_hide",
    STEP_RESUME: "tutorial_step_resume"
};
